import { Modal, type ModalProps } from 'antd'
import { useTranslation } from 'react-i18next'

/**
 * Same props as antd `Modal`. `destroyOnClose` stays accepted so a popup that must keep its
 * content while closed can say `destroyOnClose={false}`.
 */
export type PopupProps = ModalProps

/**
 * The dealer backoffice popup window — every popup of the dealer backoffice is this component
 * (관리자 BO 개발항목 194와 같은 모듈 — 딜러 BO 개발항목 294, AGENTS.md "같은 기능은 한곳에서만 구현한다"). Screens do not import antd `Modal`
 * (ESLint `no-restricted-imports` blocks it), so what all popups share is decided here:
 *
 * - closed popups are unmounted — reopening starts from a clean form, not the last input
 * - the cancel button reads `common.buttons.cancel`
 *
 * Any antd `Modal` prop passed in overrides these defaults.
 * For a read-only detail view use `DetailPopup`, for a yes/no question `confirmPopup`.
 */
export function Popup({
  destroyOnClose,
  destroyOnHidden,
  cancelText,
  ...rest
}: PopupProps): React.JSX.Element {
  const { t } = useTranslation()
  return (
    <Modal
      destroyOnHidden={destroyOnHidden ?? destroyOnClose ?? true}
      cancelText={cancelText ?? t('common.buttons.cancel')}
      {...rest}
    />
  )
}
